export const hasCookie = (cookieToFind: string, allCookies: string) => {
  if (
    allCookies.split(';').some(item => item.trim().startsWith(cookieToFind))
  ) {
    return true;
  }
  return false;
};
